export const UI_SCALE_KEY = 'ui.scale';

export function getUiScale() {
  const raw = localStorage.getItem(UI_SCALE_KEY);
  const val = parseFloat(raw);
  if (!isNaN(val) && val >= 0.5 && val <= 1.5) return val;
  return 1.0;
}

export function applyUiScale(scale) {
  const clamped = Math.max(0.5, Math.min(1.5, scale || 1));
  // базовый размер Tailwind = 16px; масштабируем root rem
  const base = 16;
  document.documentElement.style.fontSize = `${(base * clamped).toFixed(2)}px`;
}

export function setUiScale(scale) {
  const clamped = Math.max(0.5, Math.min(1.5, parseFloat(scale) || 1));
  localStorage.setItem(UI_SCALE_KEY, String(clamped));
  applyUiScale(clamped);
}


